// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.1906 3.59226C16.5938 2.3434 15.2178 1.68179 13.8797 2.32037C12.5416 2.95896 11.9715 4.47338 12.5317 5.80283C13.092 7.13227 15.343 10.4879 15.343 10.4879C15.343 10.4879 18.9702 8.70733 20.1201 7.83612C21.27 6.96492 21.5548 5.36358 20.6939 4.14624C19.833 2.9289 18.3319 2.80912 17.1906 3.59226Z"
      clipRule="evenodd"
      opacity={0.12}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M6 20.088H8.61029C8.95063 20.088 9.28888 20.1285 9.61881 20.2095L12.3769 20.8798C12.9753 21.0255 13.5988 21.0397 14.2035 20.9223L17.253 20.329C18.0585 20.1721 18.7996 19.7863 19.3803 19.2214L21.5379 17.1226C22.154 16.5242 22.154 15.5533 21.5379 14.9539C20.9832 14.4143 20.1047 14.3536 19.4771 14.8112L16.9626 16.6457C16.6025 16.909 16.1643 17.0507 15.7137 17.0507H13.2855L14.8311 17.0506C15.7022 17.0506 16.4079 16.3642 16.4079 15.5168V15.21C16.4079 14.5064 15.9156 13.8928 15.2141 13.7227L12.8286 13.1426C12.4404 13.0485 12.0428 13.0009 11.6431 13.0009C10.6783 13.0009 8.93189 13.7997 8.93189 13.7997L6 15.0258M2 14.6009L2 20.4009C2 20.9609 2 21.2409 2.10899 21.4549C2.20487 21.643 2.35785 21.796 2.54601 21.8919C2.75992 22.0009 3.03995 22.0009 3.6 22.0009H4.4C4.96005 22.0009 5.24008 22.0009 5.45399 21.8919C5.64215 21.796 5.79513 21.643 5.89101 21.4549C6 21.2409 6 20.9609 6 20.4009V14.6009C6 14.0408 6 13.7608 5.89101 13.5469C5.79513 13.3587 5.64215 13.2057 5.45399 13.1099C5.24008 13.0009 4.96005 13.0009 4.4 13.0009H3.6C3.03995 13.0009 2.75992 13.0009 2.54601 13.1099C2.35785 13.2057 2.20487 13.3587 2.10899 13.5469C2 13.7608 2 14.0408 2 14.6009ZM17.1914 3.59313C16.5946 2.34427 15.2186 1.68266 13.8804 2.32124C12.5423 2.95983 11.9722 4.47425 12.5325 5.8037C12.8787 6.62533 13.8707 8.22087 14.5781 9.3199C14.8394 9.72598 14.9701 9.92902 15.161 10.0478C15.3247 10.1497 15.5297 10.2046 15.7224 10.1982C15.9471 10.1908 16.1618 10.0803 16.5911 9.8593C17.7532 9.26118 19.4101 8.37542 20.1208 7.837C21.2707 6.96579 21.5556 5.36445 20.6947 4.14711C19.8337 2.92978 18.3327 2.80999 17.1914 3.59313Z"
    />
  </svg>
);
const IconSupportHeartHandFill = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconSupportHeartHandFill;
